/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

export default {
  name: 'session',
  methods: {
    isInstalled() {
      return !isNil(this.deviceId) && !isNil(this.serverUrl);
    }
  }
};
